<template>
  <modal
    class="coordinator-modal"
    name="coordinator-modal"
    height="auto"
    :scrollable="true"
    :adaptive="true"
    width="500px"
    @before-open="beforeOpen"
  >
    <div class="p-4" style="background-color: #fff;">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">Գնումների համակարգող</h5>
        <button type="button" class="close" @click="$modal.hide('coordinator-modal')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div v-if="!isCreatingNew">
        <div class="form-group">
          <label class="font-size-13 text-secondary mb-1">Ընտրել համակարգող</label>
          <select v-model="selectedCoordinatorId" class="form-control">
            <option :value="null">-- Ընտրել --</option>
            <option v-for="coordinator in coordinators" :key="coordinator.id" :value="coordinator.id">
              {{ coordinator.name }}
            </option>
          </select>
        </div>

        <div v-if="selectedCoordinator" class="mb-3 pl-1">
          <div class="font-size-13 text-secondary">{{ selectedCoordinator.email }}</div>
          <div class="font-size-13 text-secondary">{{ selectedCoordinator.phone }}</div>
          <a href="javascript:void(0)" @click="startEdit(selectedCoordinator)">Խմբագրել</a>
        </div>

        <div class="mb-3">
          <a href="javascript:void(0)" @click="startCreate">+ Ավելացնել նոր համակարգող</a>
        </div>

        <div class="text-right">
          <button
            type="button"
            class="btn btn-primary"
            :disabled="!selectedCoordinatorId || submitting"
            @click="confirm"
          >
            Հաստատել
          </button>
        </div>
      </div>

      <div v-else>
        <div class="form-group">
          <label class="font-size-13 text-secondary mb-1">Անուն Ազգանուն</label>
          <input v-model="form.name" type="text" class="form-control" />
        </div>
        <div class="form-group">
          <label class="font-size-13 text-secondary mb-1">Էլ. փոստ</label>
          <input v-model="form.email" type="email" class="form-control" />
        </div>
        <div class="form-group">
          <label class="font-size-13 text-secondary mb-1">Հեռախոս</label>
          <input v-model="form.phone" type="text" class="form-control" />
        </div>
        <div class="d-flex justify-content-between">
          <a href="javascript:void(0)" @click="cancelCreate">Չեղարկել</a>
          <button type="button" class="btn btn-primary" :disabled="!form.name || submitting" @click="saveCoordinator">
            Պահպանել
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'CoordinatorModal',
    data() {
      return {
        cpvType: null,
        coordinators: [],
        selectedCoordinatorId: null,
        isCreatingNew: false,
        editingId: null,
        submitting: false,
        form: {
          name: '',
          email: '',
          phone: '',
        },
      }
    },
    computed: {
      selectedCoordinator() {
        return this.coordinators.find(c => c.id === this.selectedCoordinatorId) || null
      },
    },
    methods: {
      async beforeOpen({ params }) {
        this.cpvType = params ? params.cpvType : null
        this.selectedCoordinatorId = null
        this.isCreatingNew = false
        this.editingId = null
        this.form = { name: '', email: '', phone: '' }
        try {
          const { data } = await this.$client.get('coordinators')
          this.coordinators = data || []
        } catch (e) {
          this.coordinators = []
        }
      },
      startCreate() {
        this.editingId = null
        this.form = { name: '', email: '', phone: '' }
        this.isCreatingNew = true
      },
      startEdit(coordinator) {
        this.editingId = coordinator.id
        this.form = { name: coordinator.name, email: coordinator.email, phone: coordinator.phone }
        this.isCreatingNew = true
      },
      cancelCreate() {
        this.isCreatingNew = false
      },
      async saveCoordinator() {
        this.submitting = true
        try {
          if (this.editingId) {
            const { data } = await this.$client.put(`coordinators/${this.editingId}`, this.form)
            const idx = this.coordinators.findIndex(c => c.id === this.editingId)
            if (idx !== -1) {
              this.coordinators.splice(idx, 1, data)
            }
            this.selectedCoordinatorId = data.id
          } else {
            const { data } = await this.$client.post('coordinators', this.form)
            this.coordinators.push(data)
            this.selectedCoordinatorId = data.id
          }
          this.isCreatingNew = false
        } catch (e) {
          this.$notify({ group: 'foo', type: 'error', text: 'Կրկին փորձեք!' })
        } finally {
          this.submitting = false
        }
      },
      async confirm() {
        if (!this.selectedCoordinatorId) {
          return
        }
        this.submitting = true
        try {
          const response = await this.$store.dispatch('organizeItender/create', {
            type: this.cpvType,
            coordinatorId: this.selectedCoordinatorId,
          })
          if (response.data.status) {
            const route = `/organizator/itender/prepare-invitation/${response.data.data.id}`
            this.$modal.hide('coordinator-modal')
            this.$router.push({
              path: route,
              query: {
                cpvType: this.cpvType,
                mode: 'edit',
              },
            })
          }
        } catch (e) {
          this.$notify({ group: 'foo', type: 'error', text: 'Կրկին փորձեք!' })
        } finally {
          this.submitting = false
        }
      },
    },
  }
</script>
